import formAppDeveloperOptions from './formGroupAppClientDeveloperOptions';
import formAppAnalyticsConfig from './formGroupAppClientConfigAnalyticsConfig';
import formAppEvaluatorConfig from './formGroupAppClientConfigViewEvaluatorConfig';
import formAppSharedExperiencesConfig from './formGroupAppClientConfigSharedExperiencesConfig';
import tableAppClientConfigCatalog from './tableAppClientConfigCatalog';
import formAppNonDestructiveBuffer from './formGroupAppClientConfigNonDestructiveBuffer';
import formAppLowLatency from './formGroupAppClientConfigLowLatency';
import formAppWebSocket from './formGroupAppClientConfigWebSocket';
import formAppLegacyValues from './formGroupAppClientConfigLegacyValues';
import formGroupAppClientBufferLevels from './formGroupAppClientBufferLevels';
import formGroupAppClientViewportPrediction from './formGroupAppClientViewportPrediction';
// import formGroupAppClientSponsor from './formGroupAppClientSponsor';
// import formGroupAppClientRecommendations from './formGroupAppClientRecommendations';
export default {
  title: 'Client Config',
  attributeName: 'appClientConfig',
  getURL: 'appClientConfigPlay/appId/areaId',
  createURL: '',
  updateURL: 'appClientConfigPlay/appId/areaId',
  removeURL: '',
  isClientEndpoint: true,
  sessionParams: ['appId', 'areaId'],
  loadFromFile: 'appId/areaId/appManualClientConfigFromFile',
  loadFromFileHelp: 'To load client config from file.',
  fileExtensionType: ['.yml'],
  autoUpdate: true,
  formConfig: [
    formGroupAppClientBufferLevels,
    formAppEvaluatorConfig,
    // formGroupAppClientSponsor,
    formAppNonDestructiveBuffer,
    formGroupAppClientViewportPrediction,
    formAppAnalyticsConfig,
    formAppSharedExperiencesConfig,
    formAppLowLatency,  
    formAppWebSocket,
    formAppDeveloperOptions,
    formAppLegacyValues,
    // formGroupAppClientRecommendations,
  ],
};
